export function playNationalAnthem(countryCode) {
    const audio = new Audio(`sounds/national_anthems/${countryCode.toLowerCase()}.mp3`);
    audio.play().catch(error => {
        console.error('Error playing national anthem:', error);
    });
}

export default {
    playNationalAnthem
};